// src/utils/uploadTestimonialImage.js
const imageCompression = (await import("browser-image-compression")).default;
import { getSupabase } from "../lib/supabase";

export async function uploadTestimonialImage(file) {
  // 1️⃣ Compress image (logos & brand images need less detail)
  const compressed = await imageCompression(file, {
    maxSizeMB: 0.35, // smaller than insights
    maxWidthOrHeight: 1200, // testimonials never need more
    useWebWorker: true,
  });

  // 2️⃣ Generate storage path
  const ext = compressed.name.split(".").pop();
  const filePath = `testimonials/${crypto.randomUUID()}.${ext}`;

    const supabase = await getSupabase();


  // 3️⃣ Upload to PUBLIC bucket
  const { error } = await supabase.storage
    .from("company-logos") // ✅ your existing bucket
    .upload(filePath, compressed, {
      cacheControl: "31536000", // 1 year (important)
      upsert: false,
      contentType: compressed.type,
    });

  if (error) throw error;

  // 4️⃣ Return ONLY the file path
  return filePath;
}
